import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ICustomerMobileNumberRequest } from '../models/update-mobile.model';

export const updateMobileNumberFeatureKey = 'updateMobileNumber';

export interface UpdateMobileNumberState {
  loadUpdateMobileNumber: ICustomerMobileNumberRequest;
  loadUpdateMobileNumberResponse: string;
  loadUpdateMobileNumberFailure: Error | any;
}

export const initialState: UpdateMobileNumberState = {
  loadUpdateMobileNumber: undefined,
  loadUpdateMobileNumberResponse: undefined,
  loadUpdateMobileNumberFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.updateMobileNumberRequest, (state, action) => ({
    ...state,
    updateMobilenumber: action.request
  })),
  on(actions.updateMobileNumberSuccess, (state, action) => ({
    ...state,
    loadUpdateMobilenumberResponse: action.response
  })),
  on(actions.updateMobileNumberFailure, (state, action) => ({
    ...state,
    loadUpdateMobilenumber: action.error
  }))
);

export const updateMobileNumberRequest = (state: UpdateMobileNumberState) => state.loadUpdateMobileNumber;
export const updateMobileNumberResponse = (state: UpdateMobileNumberState) => state.loadUpdateMobileNumberResponse;
export const updateMobileNumberFailure = (state: UpdateMobileNumberState) => state.loadUpdateMobileNumberFailure;
